<template>
<div id="app" class="download-page page-template-default no-sidebar separate-containers">
  <HeadNav selectedLanguage="en" page="download" :gotodownload="download" :apk="apk" />

  <main id="downloadpage">
    <section class="download-hero">
      <div class="download-shell download-hero-shell">
        <h1>Download GB WhatsApp APK v18.80</h1>
        <figure class="download-screen">
          <img src="@/assets/gbwhatsapp-download.webp" alt="Download GB WhatsApp APK v18.80 for Android">
        </figure>
        <div class="download-action">
          <button class="download-btn" @click="downloadfrom('hero')">
            <img src="@/assets/download-line.svg" alt="">
            Download GB WhatsApp APK
          </button>
        </div>
        <div class="download-copy">
          <p>
            Get the latest <strong>GB WhatsApp v18.80 APK</strong> for Android. Check the basic file information below and download the APK to your device.
          </p>
          <p class="affiliation-note">
            <a href="/">GB WhatsApp</a> is a third-party modified app and is not affiliated with WhatsApp.
          </p>
        </div>
      </div>
    </section>

    <article class="download-shell article-shell">
      <section class="content-section">
        <h2>How to Install GB WhatsApp</h2>
        <ol class="install-list">
          <li><strong>Download</strong> the APK to your Android phone.</li>
          <li><strong>Allow installation</strong> from your browser or file manager if Android asks.</li>
          <li><strong>Install</strong> the APK and open the app.</li>
          <li><strong>Verify your number</strong> and restore your available backup if supported.</li>
        </ol>
        <p class="warning">Back up important chats before switching apps.</p>
      </section>

      <section class="content-section faq-section">
        <h2>GB WhatsApp Installation FAQ</h2>
        <div class="faq-accordion">
          <div
            v-for="(item, index) in faqs"
            :key="item.question"
            class="faq-item"
            :class="{ 'is-open': isFaqOpen(index) }"
          >
            <button
              type="button"
              class="faq-question"
              :aria-expanded="isFaqOpen(index)"
              @click="toggleFaq(index)"
            >
              <span class="faq-question-text">{{ item.question }}</span>
              <span class="faq-icon" aria-hidden="true"></span>
            </button>
            <div class="faq-answer">
              <p>{{ item.answer }}</p>
            </div>
          </div>
        </div>
      </section>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

const DEFAULT_DOMAIN = 'gbwasap.org';
const DEFAULT_APP_NAME = 'GB_gbwasap.org';
const DEFAULT_APK_URL = 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.906_gw.apk';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'download',
      apk: DEFAULT_APK_URL,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      openFaqIndexes: [],
      faqs: [
        {
          question: "Why won't the APK install?",
          answer: 'Check your Android version, available storage, and whether another WhatsApp package is causing a conflict.',
        },
        {
          question: 'Why does Android block the installation?',
          answer: 'Allow your browser or file manager to install apps from that source in Android settings.',
        },
        {
          question: "Why isn't the verification code arriving?",
          answer: 'Check your number, country code, and mobile connection. Avoid requesting multiple codes repeatedly.',
        },
        {
          question: "Why can't I restore my chats?",
          answer: 'Backup compatibility can vary between official WhatsApp and modified clients. Keep your original backup before switching.',
        },
        {
          question: 'Why does GB WhatsApp crash after installation?',
          answer: 'Make sure your Android version is supported and that the APK installed correctly. A different compatible build may be needed if the problem continues.',
        },
      ],
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk || DEFAULT_APK_URL;
          } else {
            this.apk = DEFAULT_APK_URL;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || DEFAULT_DOMAIN,
          appName: appname || DEFAULT_APP_NAME,
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = DEFAULT_APK_URL;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          } else {
            this.apk = DEFAULT_APK_URL;
          }
        });
    },
    download() {
      this.$global.download(DEFAULT_APK_URL);
    },
    toggleFaq(index) {
      if (this.openFaqIndexes.includes(index)) {
        this.openFaqIndexes = this.openFaqIndexes.filter((item) => item !== index);
      } else {
        this.openFaqIndexes = [...this.openFaqIndexes, index];
      }
    },
    isFaqOpen(index) {
      return this.openFaqIndexes.includes(index);
    },
  },
};
</script>

<style lang="scss" scoped>
#downloadpage {
  background: #f6f8f7;
  color: #25332e;
  padding: 0;
}

.download-shell {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;
}

.download-hero {
  background: #fff;
  border-bottom: 1px solid #dbe8e1;
}

.download-hero-shell {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 46px;
  padding-bottom: 42px;
}

.download-screen {
  width: min(360px, 72vw);
  margin: 28px auto 24px;
}

.download-screen img {
  display: block;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(10, 72, 50, 0.16);
}

.download-action {
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
}

.download-copy {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
}

.eyebrow {
  margin: 0 0 10px;
  color: #107b59;
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  color: #10261d;
  font-size: 44px;
  font-weight: 800;
  line-height: 1.1;
  text-align: center;
}

.content-section > h2 {
  text-align: center;
}

h2 {
  margin: 0 0 16px;
  color: #15372a;
  font-size: 28px;
  font-weight: 800;
  text-align: center;
}

h3 {
  margin: 0 0 8px;
  color: #1b3a2e;
  font-size: 18px;
  font-weight: 800;
}

p {
  color: #40544c;
  font-size: 17px;
  line-height: 1.7;
}

.affiliation-note,
.warning {
  padding: 13px 15px;
  border-left: 4px solid #d99118;
  background: #fff8e8;
  color: #574018;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 52px;
  padding: 0 26px;
  border: 0;
  border-radius: 8px;
  background: #128c62;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(18, 140, 98, 0.24);
}

.download-btn:hover {
  background: #0e7451;
}

.download-btn img {
  width: 24px;
  height: 24px;
  box-shadow: none;
  filter: brightness(0) invert(1);
}

.affiliation-note a {
  color: #107b59;
  font-weight: 700;
  text-decoration: none;
}

.affiliation-note a:hover {
  text-decoration: underline;
}

.article-shell {
  padding: 32px 0 58px;
}

.content-section {
  padding: 26px 0;
  border-bottom: 1px solid #dde8e2;
}

.content-section:last-child {
  border-bottom: 0;
}

.install-list {
  margin: 0 0 20px !important;
  padding-left: 0;
  list-style-position: inside;
}

.install-list li {
  margin-bottom: 12px;
  color: #40544c;
  line-height: 1.68;
}

.faq-accordion {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.faq-item {
  overflow: hidden;
  border: 1px solid #dbe8e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px 18px;
  border: 0;
  background: transparent;
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
}

.faq-question-text {
  flex: 1;
}

.faq-icon {
  position: relative;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
}

.faq-icon::before,
.faq-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  background: #15372a;
  transform: translate(-50%, -50%);
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.faq-icon::before {
  width: 12px;
  height: 2px;
}

.faq-icon::after {
  width: 2px;
  height: 12px;
}

.faq-item.is-open .faq-icon::after {
  transform: translate(-50%, -50%) scaleY(0);
  opacity: 0;
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.28s ease;
}

.faq-item.is-open .faq-answer {
  max-height: 240px;
}

.faq-answer p {
  margin: 0;
  padding: 0 18px 16px;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 820px) {
  h1 {
    font-size: 34px !important;
  }

  h2 {
    font-size: 25px !important;
  }
}

@media (max-width: 520px) {
  .download-shell {
    padding-left: 20px;
    padding-right: 20px;
  }

  .download-btn {
    width: 100%;
    padding: 0 12px;
    font-size: 14px;
  }

  .faq-question {
    padding: 14px 16px;
    font-size: 15px;
  }

  .faq-answer p {
    padding: 0 16px 14px;
    font-size: 13px;
  }
}
</style>
